import React from 'react';
export const RefundPolicy = () => {
  return <div className="w-full" data-id="element-438">
      {/* Header */}
      <div className="bg-primary py-16 w-full" data-id="element-439">
        <div className="container mx-auto px-4" data-id="element-440">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-441">
            Refund Policy
          </h1>
          <p className="text-xl text-white/90" data-id="element-442">
            Information about refunds for Prismedge service plans
          </p>
        </div>
      </div>
      {/* Content */}
      <section className="py-16 bg-light" data-id="element-443">
        <div className="container mx-auto px-4" data-id="element-444">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-445">
            <h2 className="text-2xl font-bold text-primary mb-6" data-id="element-446">
              Refund Policy – Prismedge
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-447">
              Thank you for choosing Prismedge. We value your trust and are
              committed to ensuring your complete satisfaction with our
              services. If you have any concerns about your service plan or
              purchase, we'll work quickly and fairly to resolve them.
            </p>
            <div className="space-y-8" data-id="element-448">
              <div data-id="element-449">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-450">
                  Cancellation & Refund Rights
                </h3>
                <p className="text-gray-600" data-id="element-451">
                  You have the right to cancel your service plan within 14 days
                  of purchase and receive a full refund. To do this, please
                  contact us within the 14-day period, and we'll process your
                  refund promptly.
                </p>
                <p className="text-gray-600 mt-3" data-id="element-452">
                  If you cancel after 14 days but within 28 days of purchase,
                  you may be eligible for a partial refund at our discretion,
                  depending on any services already provided under your plan.
                </p>
                <p className="text-gray-600 mt-3" data-id="element-453">
                  Please note that refunds or cancellations are not available
                  after 28 days from the purchase date. We recommend reviewing
                  your service plan carefully and contacting us as soon as
                  possible if you wish to cancel.
                </p>
              </div>
              <div data-id="element-454">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-455">
                  How to Request a Refund
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-456">
                  To request a refund, please get in touch with our team using
                  the contact details below:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-457">
                  <li data-id="element-458">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-primary hover:underline" data-id="element-459">
                      0800 055 4969
                    </a>
                  </li>
                  <li data-id="element-460">
                    Email:{' '}
                    <a href="mailto:rawalraj2057@gmail.com" className="text-primary hover:underline" data-id="element-461">
                      rawalraj2057@gmail.com
                    </a>
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-462">
                  We'll assess your request promptly and process any approved
                  refunds. You'll receive confirmation once your refund has been
                  completed.
                </p>
              </div>
              <div data-id="element-463">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-464">
                  Payment Methods
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-465">
                  Prismedge accepts payments via:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-466">
                  <li data-id="element-467">Phone card payments</li>
                  <li data-id="element-468">Online payments through our website</li>
                  <li data-id="element-469">Cheques by post (please contact us for details)</li>
                  <li data-id="element-470">BACS or Direct Debit</li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-471">
                  Your 14-day cancellation right applies regardless of payment
                  method.
                </p>
              </div>
              <div data-id="element-472">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-473">
                  Refund Processing
                </h3>
                <p className="text-gray-600" data-id="element-474">
                  All refunds will be issued to the original payment method used
                  at purchase. For security reasons, refunds cannot be made to
                  alternative accounts or cards.
                </p>
              </div>
              <div data-id="element-475">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-476">
                  Payment Follow-Up
                </h3>
                <p className="text-gray-600" data-id="element-477">
                  After purchasing a plan, Prismedge will contact you to confirm
                  activation and inform you when payment will be processed.
                  Please ensure sufficient funds are available. If payment
                  fails, we'll contact you to confirm whether you wish to
                  proceed. Without a timely response, your plan will be
                  cancelled.
                </p>
              </div>
              <div data-id="element-478">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-479">
                  Authorised Payments
                </h3>
                <p className="text-gray-600" data-id="element-480">
                  Payments must be made by the plan holder or an authorised
                  individual. We don't accept payments made under power of
                  attorney or other third-party authorisations.
                </p>
              </div>
              <div data-id="element-481">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-482">
                  Claims & Support
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-483">
                  To book a repair or submit a claim, please contact us
                  immediately:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-484">
                  <li data-id="element-485">
                    Email:{' '}
                    <a href="mailto:rawalraj2057@gmail.com" className="text-primary hover:underline" data-id="element-486">
                      rawalraj2057@gmail.com
                    </a>
                  </li>
                  <li data-id="element-487">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-primary hover:underline" data-id="element-488">
                      0800 055 4969
                    </a>
                  </li>
                </ul>
                <p className="text-gray-600 mt-4" data-id="element-489">
                  Our team will assist you and begin the repair process
                  promptly.
                </p>
              </div>
              <div data-id="element-490">
                <h3 className="text-xl font-bold text-primary mb-3" data-id="element-491">
                  Dispute Resolution
                </h3>
                <p className="text-gray-600" data-id="element-492">
                  If you have any issues related to payment or service, please
                  contact Prismedge first before raising a chargeback with your
                  bank. We aim to resolve all concerns fairly and promptly.
                  Initiating a chargeback without prior contact may delay your
                  refund.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};